<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="inner-page">
            <b-col v-if="transferItems.length">
                <transfer @set-items="items => getItems(items)" :transferItems="transferItems"
                    :transferOrderTypes="transferOrderTypes" :title="$translate('transfer_section_items')" />
            </b-col>
            <b-col v-else>
                <b-tabs card align="center" v-model="tabIdx">
                    <b-tab :title="$translate('warehouse_inventory')">
                        <list-items ref="table"> </list-items>
                    </b-tab>
                    <b-tab :title="$translate('inventory_history')">
                        <HistoryListItems v-if="tabIdx === 1"></HistoryListItems>
                    </b-tab>
                    <b-tab :title="$translate('inventory_transfer_settings')">
                        <TransferSettings ref="settingsRef" :transfer-types="TRANSFER_TYPES"
                            :get-specified-order-types="getSpecifiedOrderTypes"
                            :transfer-order-types="transferOrderTypes"
                            @update-order-types="evt => (transferOrderTypes = evt)" @update="updateTransferTypes" />
                    </b-tab>
                </b-tabs>
            </b-col>
        </div>
    </b-overlay>
</template>
<script>
import Transfer from './Transfer.vue'
import ListItems from './ListItems'
import HistoryListItems from './HistoryListItems'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import showItemHelper from '@/mixins/showItemHelper'
import TransferSettings from './TransferSettings.vue'

import { templates } from '@/exports/jsreport_templates'

export default {
    name: 'inventoryTransfer',
    components: {
        ListItems,
        Transfer,
        HistoryListItems,
        TransferSettings,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins],
    data: () => {
        return {
            loading: false,
            tabIdx: 0,
            item: null,
            transferOrderTypes: {
                sectionSection: null,
                sectionOfficer: null,
                sectionLoss: null,
                officerLoss: null,
                officerSection: null,
                lossSection: null,
            },
        }
    },
    created() {
        Promise.all([
            this.$store.dispatch("orderType/setTransferTypes"),
            this.$store.dispatch('itemType/fetchAll'),
            this.$store.dispatch('locations/fetchWarehouses'),
            this.$store.dispatch('assets/listVendors'),
            this.$store.dispatch('users/fetchAll'),
            this.$store.dispatch('orderType/fetchAll'),
            this.$store.dispatch('transactionType/fetchOptions')]).then(() => {
                this.setDefaultSettings();
            });
        ////this.$store.dispatch('masterItem/fetchallMaster')
    },
    mounted() {
        this.$store.commit('masterItem/SET_TRANSFER_ITEMS', [])
        this.$store.dispatch(
            'company/fetchConfiguration',
            this.inventoryTransferKey
        )
        console.log('orderTypes:', this.orderTypes)
        console.log('transactionOptions:', this.transactionOptions)
        this.setconfigurations(this.configurations)
    },
    computed: {
        orderTypes() {
            return this.$store.state.orderType.items || []
        },
        transactionOptions() {
            return this.$store.state.transactionType.options
        },
        TRANSFER_TYPES() {
            return {
                sectionSection: 0,
                sectionOfficer: 1,
                sectionLoss: 2,
                officerLoss: 3,
                officerSection: 4,
                lossSection: 5,
            }
        },
        configurations() {
            return this.$store.getters['company/configurations']
        },
        inventoryTransferKey() {
            return this.$store.state.company.settingKeys.inventoryTransferKey
        },
        reportList() {
            return [
                {
                    id: 'history-report',
                    value: templates.RPT_SVR_PDF_TEMPLATE,
                    extension: 'pdf',
                    name: 'history-report',
                    label: this.$translate('history_report'),
                },
            ]
        },
        reportQuery() {
            return (
                this.$refs.historytable &&
                this.$refs.historytable.getReportQuery()
            )
        },
        transferItems() {
            return this.$store.state.masterItem.transfer_items || []
        },
    },
    watch: {
        tabIdx: function (val) {
            console.log('tabIdx', val)
        },
        transferOrderTypes: {
            handler: function (val) {
                console.log('watch---transferOrderTypes--', val)
            },
            deep: true,
        },
        configurations: {
            handler: function (_configurations) {
                this.setconfigurations(_configurations)
            },
            deep: true,
        },
    },

    methods: {
        async setDefaultSettings() {
            const TYPES = [
                { key: "sectionSection", entity: 'Internal', flow: 'Outbound', reference_entity: 'Internal' },
                { key: "sectionOfficer", entity: 'Officer', flow: 'Outbound', reference_entity: 'Internal' },
                { key: "sectionLoss", entity: 'Internal', flow: 'Inbound', reference_entity: 'Black Hole' },
                { key: "officerLoss", entity: 'Officer', flow: 'Inbound', reference_entity: 'Black Hole' },
                { key: "officerSection", entity: 'Officer', flow: 'Inbound', reference_entity: 'Internal' },
                { key: "lossSection", entity: 'Internal', flow: 'Outbound', reference_entity: 'Black Hole' },
            ];
            for (const _type of TYPES) {
                const types = this.getSpecifiedOrderTypes(_type.entity, _type.flow, _type.reference_entity);
                if (!this.transferOrderTypes[_type.key] || !types.some(x => x == this.transferOrderTypes[_type.key])) {
                    this.transferOrderTypes[_type.key] = types[0].id;
                }
            }
            await this.updateTransferTypes(true);
        },
        alertSuccess(message) {
            this.doToast(this.$translate('success'), message, 'success')
        },

        showReportDialog() {
            return this.$refs.reportsDialog.show()
        },

        getItems(items) {
            this.$nextTick(() => {
                this.$store.dispatch('masterItem/fetchSelectedItems', items)
                this.doToast(this.$translate('success'), this.$translate('transfer_success_alert'), 'success')
            })
        },
        getSpecifiedOrderTypes(entityText, flowText, referenceText) {
            console.log("getSpecifiedOrderTypes params:", { entityText, flowText, referenceText })
            const _entity = this.transactionOptions.entities[entityText]
            const _flow = this.transactionOptions.flows[flowText]
            const _reference = this.transactionOptions.entities[referenceText]
            console.log("getSpecifiedOrderTypes derived:", { _entity, _flow, _reference })
            const orderTypes = this.orderTypes.filter(
                ({ transaction_type: { entity, flow, reference_entity } }) =>
                    entity === _entity &&
                    flow === _flow &&
                    reference_entity === _reference
            )
            console.log("getSpecifiedOrderTypes orderTypes:", orderTypes)
            return orderTypes;
        },
        async updateTransferTypes(isSilent = false) {
            try {
                this.loading = true;
                const key = this.inventoryTransferKey
                const text_value = JSON.stringify(this.transferOrderTypes)
                const bool_value = false
                const obj = { key, text_value, bool_value }
                await this.$store.dispatch('company/updateConfiguration', obj)
                if (!isSilent) {
                    this.genericToast(
                        this.$translate("inventory_transfer_settings"),
                        '',
                        "success",
                        `${this.$translate("inventory_transfer_settings")} ${this.$translate("update_alert")}`
                    );
                }
            } catch (err) {
                console.error("updateTransferTypes error", err)
            } finally {
                this.loading = false;
            }
        },

        setconfigurations(_configurations) {
            const key = this.inventoryTransferKey
            console.log('configurations:', _configurations)
            console.log('key:', key)
            const setting_raw = (_configurations || []).find(x => x.key === key)
            console.log('selected configuration-before:', setting_raw)
            let settings = {}
            try {
                settings = JSON.parse(setting_raw.text_value)
            } catch (err) {
                settings = {}
            }
            console.log('selected configuration-parsed:', settings)
            let {
                sectionSection,
                sectionOfficer,
                sectionLoss,
                officerLoss,
                officerSection,
                lossSection,
            } = settings

            sectionSection = sectionSection || null
            sectionOfficer = sectionOfficer || null
            sectionLoss = sectionLoss || null
            officerLoss = officerLoss || null
            officerSection = officerSection || null
            lossSection = lossSection || null

            this.transferOrderTypes = {
                sectionSection,
                sectionOfficer,
                sectionLoss,
                officerLoss,
                officerSection,
                lossSection,
            }
        },
    },
}
</script>
<style></style>
